/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Řežnák a Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {logWarning} from "App/debug";

export default
class ObservableSubject {
    private _registeredObservers: any[] = [];

    constructor() {
    }

    public registerObserver(aObserver): void {
        // Test if object exists in array
        for (let i = 0; i < this._registeredObservers.length; i++) {
            if (this._registeredObservers[i] === aObserver) {
                return;
            }
        }

        this._registeredObservers.push(aObserver);
    }

    public unregisterObserver(aObserver: any) {
        // Test if object exists in array
        let index = -1;
        for (let i = 0; i < this._registeredObservers.length; i++) {
            if (this._registeredObservers[i] === aObserver) {
                index = i;
                this._registeredObservers.splice(i, 1);
                return;
            }
        }
    }

    public notifyObservers(aMethod: string, aArgs: any) {
        for (let i = 0; i < this._registeredObservers.length; i++) {
            if (this._registeredObservers[i][aMethod] !== undefined) {
                this._registeredObservers[i][aMethod].apply(this._registeredObservers[i], aArgs);
            } else {
                logWarning("Callback method " + aMethod + " does not exists on observer " + typeof this._registeredObservers[i]);
            }
        }
    }
}
